(function () {
  const STORAGE_KEY = 'carla:recently-viewed';
  const MAX_STORED = 12;
  function readItems() {
    try { const raw = localStorage.getItem(STORAGE_KEY); const parsed = raw ? JSON.parse(raw) : []; return Array.isArray(parsed) ? parsed : []; }
    catch (e) { return []; }
  }
  function writeItems(items) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(items)); } catch (e) { /* storage unavailable */ }
    document.dispatchEvent(new CustomEvent('recently-viewed:change', { detail: { items } }));
  }
  function addProduct(product) {
    if (!product || !product.id) return;
    const items = readItems().filter((item) => String(item.id) !== String(product.id));
    items.unshift({ id: product.id, handle: product.handle || '', title: product.title || '', url: product.url || '', image: product.image || '', price: product.price || '', type: product.type || '', variant_id: product.variant_id || '', variants_count: product.variants_count || 1 });
    writeItems(items.slice(0, MAX_STORED));
  }
  function getCurrentProductId() {
    const track = document.getElementById('RecentlyViewedTrack');
    if (!track) return null;
    try { return JSON.parse(track.textContent).id || null; } catch (e) { return null; }
  }
  function escapeHtml(value) {
    return String(value ?? '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function starSvg() {
    return '<svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"></path></svg>';
  }
  function buildCard(product, config) {
    const title = escapeHtml(product.title);
    const url = escapeHtml(window.CarlaLocalizedProducts?.url(product) || product.url);
    const image = escapeHtml(product.image);
    const price = escapeHtml(product.price);
    const type = escapeHtml(product.type);
    let ratingHtml = '';
    if (config.show_rating) {
      const count = escapeHtml(config.rating_count || '24');
      ratingHtml = '<div class="recently-viewed-custom__rating"><div class="recently-viewed-custom__stars" aria-hidden="true">' + starSvg().repeat(5) + '</div><span class="recently-viewed-custom__rating-count">(' + count + ')</span></div>';
    }
    const typeHtml = config.show_product_type && type ? '<p class="recently-viewed-custom__type">' + type + '</p>' : '';
    const imageHtml = image ? '<img class="recently-viewed-custom__image" alt="' + title + '" src="' + image + '" loading="lazy" width="360" height="480">' : '';
    return '<a class="recently-viewed-custom__card group" href="' + url + '"><div class="recently-viewed-custom__media">' + imageHtml + '</div><div class="recently-viewed-custom__info"><div class="recently-viewed-custom__details"><h3 class="recently-viewed-custom__title">' + title + '</h3>' + ratingHtml + typeHtml + '</div><div class="recently-viewed-custom__price-wrap"><p class="recently-viewed-custom__price">' + price + '</p></div></div></a>';
  }
  function initSection(root) {
    const renderToken = {};
    root.carlaRecentRenderToken = renderToken;
    let config = {};
    try { config = JSON.parse(root.dataset.recentlyViewedConfig || '{}'); } catch (e) { /* default settings */ }
    const grid = root.querySelector('[data-recently-viewed-grid]');
    const shopifySection = root.closest('.shopify-section');
    if (!grid) return;
    const limit = Number(config.products_to_show) || 4;
    const excludeId = config.exclude_current_product ? getCurrentProductId() : null;
    let items = readItems();
    if (excludeId) items = items.filter((item) => String(item.id) !== String(excludeId));
    items = items.slice(0, limit);
    if (!items.length) {
      if (shopifySection) { shopifySection.hidden = true; shopifySection.classList.remove('recently-viewed-custom--visible'); }
      return;
    }
    if (shopifySection) { shopifySection.hidden = false; shopifySection.classList.add('recently-viewed-custom--visible'); }
    grid.innerHTML = items.map((item) => buildCard(item, config)).join('');
    if (!window.CarlaLocalizedProducts) return;
    const cards = Array.from(grid.querySelectorAll('.recently-viewed-custom__card'));
    items.forEach((item, index) => {
      window.CarlaLocalizedProducts.get(item).then((localized) => {
        if (!root.isConnected || root.carlaRecentRenderToken !== renderToken) return;
        const card = cards[index];
        if (!card || !card.isConnected) return;
        card.setAttribute('href', window.CarlaLocalizedProducts.url(localized));
        const title = card.querySelector('.recently-viewed-custom__title');
        if (title) title.textContent = localized.title || '';
        const image = card.querySelector('img');
        if (image) { image.alt = localized.title || ''; if (localized.image) image.src = localized.image; }
        const price = card.querySelector('.recently-viewed-custom__price');
        if (price) price.textContent = localized.price || '';
        const type = card.querySelector('.recently-viewed-custom__type');
        if (type) type.textContent = localized.type || '';
      });
    });
  }
  function initAll() { document.querySelectorAll('[data-recently-viewed]').forEach(initSection); }
  function trackFromPage() {
    const track = document.getElementById('RecentlyViewedTrack');
    if (!track) return;
    try { addProduct(JSON.parse(track.textContent)); } catch (e) { /* invalid JSON */ }
  }
  document.addEventListener('DOMContentLoaded', () => { trackFromPage(); initAll(); });
  document.addEventListener('recently-viewed:change', initAll);
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('[data-recently-viewed]');
    if (section) initSection(section);
  });
})();
